import { useEffect, useState } from 'react';

const OrientationGuard = ({ children }) => {
  const [showWarning, setShowWarning] = useState(false);

  const checkOrientation = () => {
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isPortrait = window.matchMedia("(orientation: portrait)").matches;
    setShowWarning(isMobile && !isPortrait);
  };

  useEffect(() => {
    checkOrientation(); // Verifica ao montar

    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (showWarning) {
    return (
      <div className="fixed inset-0 bg-black text-white flex items-center justify-center text-center p-4 z-50">
        <div>
          <h1 className="text-2xl font-bold mb-4">Por favor, use o dispositivo na orientação <strong>retrato</strong>.</h1>
          <p>O modo paisagem (landscape) não é suportado em dispositivos móveis.</p>
        </div>
      </div>
    );
  }

  return children;
};

export default OrientationGuard;
